"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const clsx = require("../../../../chunks/clsx-CBkIpawf.js");
const Modal_module = require("../../../../chunks/Modal.module-DOd1Y64p.js");
const ModalBackdrop = ({ children, className, ...props }) => {
  return /* @__PURE__ */ jsxRuntime.jsx("div", { className: clsx.clsx(Modal_module.styles.modalBackdrop, className), ...props, children });
};
exports.ModalBackdrop = ModalBackdrop;
